import React, { useContext, useEffect, useState } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Fragment } from 'react'
import { ContactContext } from './Contact'
import { AuthContext } from '../../../App/App';
import axios from 'axios'
import qs from 'querystring'
import swal from 'sweetalert';

function ModalAddEditContact() {
    const { stateContact, dispatchContact } = useContext(ContactContext)
    const { stateAuth, dispatchAuth } = useContext(AuthContext);

    const handleCencelClick = (event) => {
        event.preventDefault()
        dispatchContact({
            type: "SELECTED",
            selected: null
        })

        dispatchContact({
            type: "MODAL_ADD_EDIT",
            modalAddEdit: {
                status: !stateContact.modalAddEdit.status,
                action: null
            }
        })

        setdataForm(initialDataForm)
    }

    const handleSubmitClick = (event) => {
        event.preventDefault();
        if (dataForm.username != '' && dataForm.phonenumber != '') {
            if (stateContact.modalAddEdit.action == "add") Add()
            else if (stateContact.modalAddEdit.action == "edit") Edit()
        } else {
            setdataForm({
                ...dataForm,
                errUsername: (dataForm.username === '') ? 'Please enter username.' : null,
                errPhone: (dataForm.phonenumber === '') ? `Please enter phone number.` : null
            })
        }
    }

    const handleInputChange = (event) => {
        if (event.target.validity.valid) {
            setdataForm({
                ...dataForm,
                [event.target.name]: event.target.value,
                errUsername: (event.target.name == 'username') ? (event.target.value == '') ? 'Please enter username.' : null : dataForm.errUsername,
                errPhone: (event.target.name == 'phonenumber') ? (event.target.value == '') ? `Please enter phone number.` : null : dataForm.errPhone
            })
        }
    }

    function Add() {
        const reqBody = {
            username: dataForm.username,
            phonenumber: dataForm.phonenumber
        }
        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-access-token': localStorage.getItem('token-helpdesk-umy')
            }
        }

        axios.post('/api/v1/helpdesk/setting/contact/create', qs.stringify(reqBody), config)
            .then(res => {
                dispatchContact({
                    type: "INSERTED",
                    contact: { id: res.data.id, username: dataForm.username, phone: dataForm.phonenumber }
                })

                dispatchContact({
                    type: "MODAL_ADD_EDIT",
                    modalAddEdit: {
                        status: !stateContact.modalAddEdit.status,
                        action: null
                    }
                })

                setdataForm(initialDataForm)

                swal("Success!", `${res.data.message}`, "success", {
                    button: "OK",
                });
            })
            .catch(err => {
                if (!err.response || err.code === 'ECONNABORTED') {
                    swal("Error!", "Check Your Internet Connection!", "error", {
                        button: "OK",
                    });
                } else if (err.response) {
                    if (err.response.data.status === 'jwt' && err.response.data.message === `TokenExpiredError`) {
                        dispatchAuth({
                            type: "LOGOUT",
                            message: 'Token expired, please login again...'
                        })
                    } else if (err.response.data.status === 'invalid') {
                        let username = null
                        let phone = null
                        err.response.data.errors.map(err => {
                            username = (err.param === 'username') ? err.msg : username
                            phone = (err.param === 'phonenumber') ? err.msg : phone
                        })

                        setdataForm({
                            ...dataForm,
                            errPhone: phone,
                            errUsername: username
                        })
                    } else if (err.response.data.status === 'duplicate') {
                        setdataForm({
                            ...dataForm,
                            errPhone: err.response.data.message
                        })
                    } else {
                        swal("Error!", `${err.response.data.message}`, "error", {
                            button: "OK",
                        });
                    }
                }
            })
    }

    function Edit() {
        const reqBody = {
            username: dataForm.username,
            phonenumber: dataForm.phonenumber
        }
        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-access-token': localStorage.getItem('token-helpdesk-umy')
            }
        }

        axios.put(`/api/v1/helpdesk/setting/contact/update-contact/${stateContact.selected}`, qs.stringify(reqBody), config)
            .then(res => {
                setdataForm(initialDataForm);

                const data = {
                    id: stateContact.selected,
                    username: dataForm.username,
                    phone: dataForm.phonenumber
                }
                dispatchContact({
                    type: "TRIGGER",
                    trigger: "update-contact",
                    temp: data,
                })
                dispatchContact({
                    type: "MODAL_ADD_EDIT",
                    modalAddEdit: {
                        status: !stateContact.modalAddEdit.status,
                        action: null
                    }
                })
                swal("Success!", `${res.data.message}`, "success", {
                    button: "OK",
                });
            })
            .catch(err => {
                if (!err.response || err.code === 'ECONNABORTED') {
                    swal("Error!", "Check Your Internet Connection!", "error", {
                        button: "OK",
                    });
                } else if (err.response) {
                    if (err.response.data.status === 'jwt' && err.response.data.message === `TokenExpiredError`) {
                        dispatchAuth({
                            type: "LOGOUT",
                            message: 'Token expired, please login again...'
                        })
                    } else if (err.response.data.status === 'invalid') {
                        let username = null
                        let phone = null
                        err.response.data.errors.map(err => {
                            username = (err.param === 'username') ? err.msg : username
                            phone = (err.param === 'phonenumber') ? err.msg : phone
                        })

                        setdataForm({
                            ...dataForm,
                            errPhone: phone,
                            errUsername: username
                        })
                    } else {
                        swal("Error!", `${err.response.data.message}`, "error", {
                            button: "OK",
                        });
                    }
                }
            })
    }


    const initialDataForm = {
        username: '',
        phonenumber: '',
        errUsername: null,
        errPhone: null
    }
    const [dataForm, setdataForm] = useState(initialDataForm)
    const [renderModal, setrenderModal] = useState(<Fragment />)

    useEffect(() => {
        //find selected data
        if (stateContact.selected != null && stateContact.modalAddEdit.action == "edit") {
            const cnt = stateContact.contacts.find(cnt => cnt.id == stateContact.selected)
            setdataForm({
                ...dataForm,
                username: cnt.username,
                phonenumber: cnt.phone
            })
        }

    }, [stateContact.modalAddEdit])

    useEffect(() => {
        if (stateContact.modalAddEdit.status == true) {
            setrenderModal(
                <Fragment>
                    <Modal className="modal-dialog modal-dialog-centered" isOpen={stateContact.modalAddEdit.status} backdrop={true} keyboard={true}>
                        <ModalHeader toggle={handleCencelClick} charCode={<i className="fas fa-times-circle" style={{ fontSize: '20px' }}></i>}>
                            {stateContact.modalAddEdit.action == "add" ? `Add New Contact` : `Edit Contact`}
                        </ModalHeader>
                        <ModalBody>
                            <div className="form-group row">
                                <label htmlFor="username" className="col-form-label">Username</label>
                                <div className="input-group  has-validation">
                                    <input type="text" value={dataForm.username} className={`form-control ${dataForm.errUsername != null ? 'is-invalid' : ''}`} id="username" name="username" autoFocus onChange={handleInputChange} placeholder="Username" aria-describedby="validationUsername" />
                                    <div id="validationUsername" className="invalid-feedback">
                                        <small>{dataForm.errUsername}</small>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label htmlFor="phonenumber" className="col-form-label">Phone Number</label>
                                <div className="input-group  has-validation">
                                    <input pattern="[0-9]*" type="text" value={dataForm.phonenumber} className={`form-control ${dataForm.errPhone != null ? 'is-invalid' : ''}`} id="phonenumber" name="phonenumber" onChange={handleInputChange} placeholder="Phone Number" aria-describedby="validationPhonenumber" />
                                    <div id="validationPhonenumber" className="invalid-feedback">
                                        <small>{dataForm.errPhone}</small>
                                    </div>
                                </div>
                            </div>
                        </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" style={{ textTransform: 'capitalize' }} onClick={handleCencelClick}>Cancel</Button>
                            <Button color="primary" style={{ textTransform: 'capitalize' }} onClick={handleSubmitClick}> {stateContact.modalAddEdit.action == "add" ? (<Fragment>Add Contact <i className="fas fa-user-plus"></i></Fragment>) : (<Fragment>Edit Contact <i className="fas fa-edit"></i></Fragment>)} </Button>
                        </ModalFooter>
                    </Modal>
                </Fragment>)
        } else if (stateContact.modalAddEdit.status == false) {
            setrenderModal(<Fragment />)
        }
    }, [dataForm, stateContact.modalAddEdit])

    return (
        renderModal
    )
}

export default ModalAddEditContact
